import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { createStructuredSelector, createSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { userSelector } from 'selectors/user/userSelector';
import selectedDeliveryOptionSelector from 'selectors/modals/chooseOptionsModal/selectedDeliveryOptionSelector';
import ChooseOptionsActions from 'actions/ChooseOptionsActions';
import productActions from 'actions/ProductActions';
import snbApi from 'services/api/search-n-browse';
import Actions from 'actions/Actions';

const { closeChooseOptionsModal, setFromChooseOptionsModal } = ChooseOptionsActions;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;

const { wrapHOC } = FrameworkUtils;

const getText = getLocaleResourceFile('components/GlobalModals/ChooseOptionsModal/locales', 'ChooseOptionsModal');

const localization = createStructuredSelector({
    seeFullDetails: getTextFromResource(getText, 'seeFullDetails')
});

const fields = createSelector(
    localization,
    userSelector,
    selectedDeliveryOptionSelector,
    (textResources, user, selectedChooseOptionsDeliveryOption) => {
        const { preferredStoreInfo } = user || {};

        return {
            localization: textResources,
            preferredStoreInfo,
            selectedChooseOptionsDeliveryOption
        };
    }
);

const functions = {
    onCancel: closeChooseOptionsModal,
    requestClose: closeChooseOptionsModal,
    getFulfillmentOptions: productActions.getFulfillmentOptions,
    updateCurrentProduct: productActions.updateCurrentProduct,
    getProductDetailsLite: snbApi.getProductDetailsLite,
    setFromChooseOptionsModal,
    setChooseOptionsDeliveryOption: Actions.setChooseOptionsDeliveryOption
};

const withChooseOptionsModalProps = wrapHOC(connect(fields, functions));

export {
    withChooseOptionsModalProps, fields, functions
};
